const constants = {
  UD:            1,                   // UD = Earth diameter (base unit of distance used in Spacecast)
  UD_TO_MILES:   7917,                // UD in miles
  UD_TO_KM:      12742,               // UD in kilometers
  UD_TO_AU:      1 / 11740,
  UD_TO_LY:      1 / (11740 * 63241),
  LENGTH_MILE:   1 / 7917,            // 1 mile in UD
  LENGTH_AU:     11740,               // 1 astronomical unit in UD
  LENGTH_LY:     11740 * 63241,       // 1 light year in UD
  UNIVERSE_RADIUS:  11740 * 63241 * 100, // Visible space radius
  KEYCODE_ENTER: 13,
  KEYCODE_SPACE: 32,
  EARTH_ORBITAL_PERIOD_IN_SECONDS: 31558149,
}

export default constants;